/**
 * Global-consumption stat tiles: total / prompt / completion tokens +
 * active users for the selected range. Plain stat cards (the
 * DeliverablesSummaryCards shape) — no RYG tinting, consumption counts
 * have no good/bad polarity.
 */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { formatTokens, formatTokensExact } from './hooks';
function StatCard({ label, value, detail, exact, testid }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "rounded-lg border bg-card p-4",
        "data-testid": testid,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "text-xs font-medium uppercase tracking-wide text-muted-foreground",
                children: label
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mt-1 text-2xl font-semibold tabular-nums",
                title: exact,
                children: value
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "text-xs text-muted-foreground",
                children: detail
            })
        ]
    });
}
export function UsageKpis({ summary, isLoading }) {
    if (isLoading && !summary) {
        return /*#__PURE__*/ _jsx("div", {
            className: "grid grid-cols-2 gap-4 lg:grid-cols-4",
            children: [
                0,
                1,
                2,
                3
            ].map((i)=>/*#__PURE__*/ _jsx(Skeleton, {
                    className: "h-24 rounded-lg"
                }, i))
        });
    }
    const totals = summary?.totals;
    const requests = formatTokensExact(totals?.eventCount);
    return /*#__PURE__*/ _jsxs("div", {
        className: "grid grid-cols-2 gap-4 lg:grid-cols-4",
        children: [
            /*#__PURE__*/ _jsx(StatCard, {
                testid: Testids.adminUsage.kpiTotal,
                label: "Total tokens",
                value: formatTokens(totals?.totalTokens),
                exact: formatTokensExact(totals?.totalTokens),
                detail: `${requests} completions`
            }),
            /*#__PURE__*/ _jsx(StatCard, {
                testid: Testids.adminUsage.kpiPrompt,
                label: "Prompt tokens",
                value: formatTokens(totals?.promptTokens),
                exact: formatTokensExact(totals?.promptTokens),
                detail: "sent to the model"
            }),
            /*#__PURE__*/ _jsx(StatCard, {
                testid: Testids.adminUsage.kpiCompletion,
                label: "Completion tokens",
                value: formatTokens(totals?.completionTokens),
                exact: formatTokensExact(totals?.completionTokens),
                detail: "generated by the model"
            }),
            /*#__PURE__*/ _jsx(StatCard, {
                testid: Testids.adminUsage.kpiActiveUsers,
                label: "Active users",
                value: Number(summary?.activeUsers ?? 0).toLocaleString('en-US'),
                detail: "with usage in range"
            })
        ]
    });
}
